var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithBlueCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25Z",
    fill: "#667CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2604 26.7563L17.1145 34.9023L15.3047 33.0913L23.4501 24.9459L15.3047 16.8L17.1145 14.9902L25.2604 23.1356L33.4058 14.9902L35.2168 16.8L27.0709 24.9459L35.2168 33.0913L33.4058 34.9023L25.2604 26.7563Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithBlueCircle);
export default __webpack_public_path__ + "static/media/close_with_blue_circle.ba63cd5efa228e2f26b1ad1e7311f897.svg";
export { ForwardRef as ReactComponent };